export const getStyled = () => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    width: '80%',
    height: '70%',
    maxWidth: '780px',
    maxHeight: '85vh',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    border: 'none',
    padding: '0',
    background: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});
